import {
    ICommonPensionInputs,
    SimplePensionFormOfPayment,
} from "app/calcs/pensions/interfaces"
import * as moment from "moment"

enum Local697FormOfPayment {
    lifeOnly = 550,
    hundredPercentHusbandAndWife = 552,
}

interface ILocal697PensionInputs extends ICommonPensionInputs {
    beginPaymentsAge: moment.Duration
    formOfPayment: Local697FormOfPayment | SimplePensionFormOfPayment
    futureServiceCredits: number
    vestingCredits: number
    monthlyBen: number // aka: accruedBenefit
    l697SavingsBalance: number
    planPPaymentsAge: moment.Duration
    percentLumpSumElected: number
    planPEligible: boolean
    planPTotalService: number
    planPBen: number
    planPRate: number
    currentYearHours: number
    cyCredit: number
    pensionExcessHours: number
    planPExcessHours: number
    planPCyCredit: number

    // added 8/19/2022. Modified 10/6/2023
    eePreTax: number
    eeAfterTax: number
    erContrib: number
    rollover: number
    rothDeferral: number
    savingsCheck: number

    // added 01-25-2023
    futureServiceCredits1Max: number
    IOServicePost2023: number
}

export { ILocal697PensionInputs, Local697FormOfPayment }



// WEBPACK FOOTER //
// ./src/app/calcs/customers/local697/interfaces/index.ts